import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import Widget from "./Widget";
import { IQueryParams } from "../context/types";
import { useGlobalContext } from "../context/GlobalContext/GlobalContext";

export default function Home() {
  const location = useLocation();
  const { setQueryParams, setAppLoading } = useGlobalContext();

  useEffect(() => {
    // sample URL : http://localhost:3000/?apiKey=69feba7f-a1c2-4cfa-a9bd-43072768b0e6&widgetTitle=Stake%20AAVE&buttonName=Stake%20Now&contractAddress=0x794a61358D6845594F94dc1DB02A252b5b4814aD&contractFunction=depositTo&contractParams=address,address,uint256&symbol=AUSDC&network=polygon
    const parsed = queryString.parse(location.search);
    setAppLoading(true);

    let queryParams: IQueryParams = {
      apiKey: "",
      symbol: "",
      network: "",
      contractAddress: "",
      contractFunction: "",
      contractParams: "",
      widgetTitle: "",
      buttonName: "",
      extraDetails: "",
      partnerOrderId: "",
    };

    if (parsed && parsed.apiKey) queryParams.apiKey = parsed.apiKey.toString();
    if (parsed && parsed.symbol) queryParams.symbol = parsed.symbol.toString();
    if (parsed && parsed.network) queryParams.network = parsed.network.toString();
    if (parsed && parsed.contractAddress) queryParams.contractAddress = parsed.contractAddress.toString();
    if (parsed && parsed.contractFunction) queryParams.contractFunction = parsed.contractFunction.toString();
    if (parsed && parsed.contractParams) queryParams.contractParams = parsed.contractParams.toString();
    if (parsed && parsed.widgetTitle) queryParams.widgetTitle = parsed.widgetTitle.toString();
    if (parsed && parsed.buttonName) queryParams.buttonName = parsed.buttonName.toString();
    if (parsed && parsed.extraDetails) queryParams.extraDetails = parsed.extraDetails.toString();
    if (parsed && parsed.partnerOrderId) queryParams.partnerOrderId = parsed.partnerOrderId.toString();

    setQueryParams(queryParams);
    setAppLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Widget />;
}
